module.exports = __webpack_public_path__ + "img/william-wells-brown.366deadd.png";